import React, { useState, useEffect, Fragment } from "react";
import { API_URL } from "../helpers";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Checkbox from "../components/Checkbox";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Form2 = ({ token, update }) => {
  const [errors, setErrors] = useState([]);
  const [names, setNames] = useState({
    token,
  });
  const [msg, setMsg] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  useEffect(() => {
    init();

    // eslint-disable-next-line
  }, []);

  const init = async () => {
    const url = new URL(`${API_URL}/auth/charityForm2Init`);
    const params = {
      token: names.token,
    };
    url.search = new URLSearchParams(params);

    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-store",
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        handleUpdate("one", json.one);
        handleUpdate("oneDescr", json.oneDescr);
        handleUpdate("two", json.two);
        handleUpdate("twoDescr", json.twoDescr);
        handleUpdate("three", json.three);
        handleUpdate("threeDescr", json.threeDescr);
        setAlert({});
      } else {
        setAlert({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setAlert({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  const handleUpdate = (name, value) => {
    setNames((names) => ({ ...names, [name]: value ? value : "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    const url = new URL(`${API_URL}/auth/charityForm2`);
    let data = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      if (key === "remove") {
        data.append(key, value ? "1" : "0");
      } else {
        data.append(key, value);
      }
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        update("form", 0);
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <Fragment>
      {alert.type ? (
        <Alert data={alert} />
      ) : (
        <form
          method="post"
          action="/"
          onSubmit={(e) => handleSubmit(e)}
          className="well"
        >
          <h3 style={{ marginTop: "0" }}>Suggested Donations Amounts</h3>

          <p>
            Use this form to customize up to 3 donation amounts on your donation
            form (the option for donors to key in their own amount is added by
            default).
          </p>

          <div className="form-group">
            <Input
              name="one"
              label="Suggested Donation 1 Amount"
              reqd={true}
              value={names.one || ""}
              update={handleUpdate}
              errors={errors}
            />
            <Input
              name="oneDescr"
              label="Suggested Donation 1 Description"
              reqd={false}
              value={names.oneDescr || ""}
              update={handleUpdate}
              errors={errors}
            />
          </div>

          {names.one && names.oneDescr && (
            <h4 style={{ marginTop: "10px" }}>
              {`A $${names.one} donation ${names.oneDescr}`}
            </h4>
          )}

          <div className="form-group">
            <Input
              name="two"
              label="Suggested Donation 2 Amount"
              reqd={false}
              value={names.two || ""}
              update={handleUpdate}
              errors={errors}
            />
            <Input
              name="twoDescr"
              label="Suggested Donation 2 Description"
              reqd={false}
              value={names.twoDescr || ""}
              update={handleUpdate}
              errors={errors}
            />
          </div>

          {names.two && names.twoDescr && (
            <h4 style={{ marginTop: "10px" }}>
              {`A $${names.two} donation ${names.twoDescr}`}
            </h4>
          )}

          <div className="form-group">
            <Input
              name="three"
              label="Suggested Donation 3 Amount"
              reqd={false}
              value={names.three || ""}
              update={handleUpdate}
              errors={errors}
            />
            <Input
              name="threeDescr"
              label="Suggested Donation 3 Description"
              reqd={false}
              value={names.threeDescr || ""}
              update={handleUpdate}
              errors={errors}
            />
          </div>

          {names.three && names.threeDescr && (
            <h4 style={{ marginTop: "10px" }}>
              {`A $${names.three} donation ${names.threeDescr}`}
            </h4>
          )}

          <div className="form-group checkbox" style={{ marginTop: "10px" }}>
            <Checkbox
              name="remove"
              label="Check if you would like to remove your suggested donations and return to default."
              checked={names.remove || false}
              click={handleUpdate}
            />
          </div>

          <div className="msg-submit">
            {msg.type && <Msg data={msg} />}

            <div
              className={
                msg.type === "working" || msg.type === "success"
                  ? "hidden"
                  : "submit-container"
              }
            >
              <Submit path="" left="" submit="Submit Changes" />
            </div>
          </div>
        </form>
      )}
    </Fragment>
  );
};

export default Form2;
